import { useTranslation } from 'react-i18next';
import PageShell from '@/components/feature/PageShell';

export default function ShippingPage() {
  const { t } = useTranslation('pages');

  const rows = [
    ['shipping_row1_method', 'shipping_row1_speed', 'shipping_row1_best', 'shipping_row1_note'],
    ['shipping_row2_method', 'shipping_row2_speed', 'shipping_row2_best', 'shipping_row2_note'],
    ['shipping_row3_method', 'shipping_row3_speed', 'shipping_row3_best', 'shipping_row3_note'],
    ['shipping_row4_method', 'shipping_row4_speed', 'shipping_row4_best', 'shipping_row4_note'],
  ];

  return (
    <PageShell
      eyebrow={t('shipping_eyebrow')}
      title={t('shipping_h1')}
      intro={t('shipping_intro')}
    >
      <div className="space-y-10">
        <section>
          <h2 className="font-heading text-xl md:text-2xl font-semibold text-foreground-900 mb-4">
            {t('shipping_s1_title')}
          </h2>
          <p className="text-foreground-600 text-base leading-relaxed">{t('shipping_s1_body')}</p>
        </section>
        <section>
          <h2 className="font-heading text-xl md:text-2xl font-semibold text-foreground-900 mb-4">
            {t('shipping_s2_title')}
          </h2>
          <p className="text-foreground-600 text-base leading-relaxed mb-6">{t('shipping_s2_body')}</p>

          <div className="overflow-x-auto rounded-xl border border-background-200/50">
            <table className="w-full text-sm">
              <thead>
                <tr className="bg-background-100 text-left">
                  <th className="px-4 py-3 font-semibold text-foreground-800">{t('shipping_table_method')}</th>
                  <th className="px-4 py-3 font-semibold text-foreground-800">{t('shipping_table_speed')}</th>
                  <th className="px-4 py-3 font-semibold text-foreground-800">{t('shipping_table_best')}</th>
                  <th className="px-4 py-3 font-semibold text-foreground-800">{t('shipping_table_note')}</th>
                </tr>
              </thead>
              <tbody>
                {rows.map((row, i) => (
                  <tr key={i} className={i % 2 === 0 ? 'bg-background-50' : 'bg-background-100/50'}>
                    <td className="px-4 py-3 font-medium text-foreground-800">{t(row[0])}</td>
                    <td className="px-4 py-3 text-foreground-600">{t(row[1])}</td>
                    <td className="px-4 py-3 text-foreground-600">{t(row[2])}</td>
                    <td className="px-4 py-3 text-foreground-600">{t(row[3])}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
          <p className="text-foreground-400 text-xs mt-4 italic">{t('shipping_disclaimer')}</p>
        </section>
      </div>
    </PageShell>
  );
}